<template>
    <div>
        <modal ref="modal" :disable-close="true">
            <div class="flex w-full h-full bg-purple-900 items-center justify-center p-10 flex-col">
                <h1 class="font-light pb-10 md:pt-20 lowercase">{{ $t('welcome') }}</h1>

                <p class="text-center lowercase">
                    {{ $t('your_payment_was_approved_ready_to_go') }}
                </p>

                <div class="p-20 w-full">
                    <button class="btn btn-orange w-full" :disabled="loading" @click="goHome()">
                        {{ $t('continue') }}
                    </button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import {Auth, Zapin} from "@/services/Api";

    export default {
        props: {
            plan: String
        },

        mounted() {
            this.$refs.modal.open();

            this.markAsViewed();
        },

        data() {
            return {
                loading: false
            }
        },

        methods: {
            goHome() {
                this.$router.push({
                    name: 'Dashboard'
                });
            },

            markAsViewed() {
                this.loading = true;

                Promise.all([
                    Auth.currentUser()
                        .account()
                        .registerEvent('user.conversion', {
                            plan: this.plan
                        }),

                    Auth.currentUser()
                        .account()
                        .markRedirectPageViewed()
                        .then(() => {
                            Zapin.updateUserData();
                        })
                    ]
                ).finally(() => {
                    this.loading = false;
                })

            }
        }
    }
</script>